import { ServiceTicketCreate } from './ServiceTicketCreate';
import { ServiceTicketEdit } from './ServiceTicketEdit';
import { ServiceTicketList } from './ServiceTicketList';
import { ServiceTicketShow } from './ServiceTicketShow';

export const service_tickets = {
    list: ServiceTicketList,
    create: ServiceTicketCreate,
    edit: ServiceTicketEdit,
    show: ServiceTicketShow,
};

